import mixpanel from 'mixpanel-browser';

// Initialize once with your project token
// In production, set REACT_APP_MIXPANEL_TOKEN in your environment
// const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN || '422b71c48bd2bff8a8ed9f95211c2794'; 
const MIXPANEL_TOKEN = '422b71c48bd2bff8a8ed9f95211c2794'; 

// Initialize Mixpanel
mixpanel.init(MIXPANEL_TOKEN, {
  debug: process.env.NODE_ENV !== 'production',
  track_pageview: true
});

// Analytics service
const Analytics = {
  /**
   * Track page views
   * @param pageName - Name of the page
   */
  trackPageView: (pageName: string) => {
    mixpanel.track('Page View', { page: pageName });
  },

  /**
   * Track platform selection in demo
   * @param platform - Name of the platform selected
   */
  trackPlatformSelection: (platform: string) => {
    mixpanel.track('Platform Selected', { platform });
  },

  /**
   * Track message sent in demo
   * @param platform - Platform where message was sent
   * @param messageLength - Length of the message
   */
  trackMessageSent: (platform: string, messageLength: number) => {
    mixpanel.track('Message Sent', { platform, messageLength });
  },

  /**
   * Track button click events
   * @param buttonName - Name of the button clicked
   * @param location - Where the button is located
   */
  trackButtonClick: (buttonName: string, location: string) => {
    mixpanel.track('Button Click', { button: buttonName, location });
  },

  /**
   * Track pricing plan interactions
   * @param planType - Type of plan (starter, pro, enterprise)
   * @param billingPeriod - Billing period (monthly, annual)
   */
  trackPricingInteraction: (planType: string, billingPeriod: string) => {
    mixpanel.track('Pricing Interaction', { planType, billingPeriod });
  },

  /**
   * Identify a user (if applicable)
   * @param userId - User ID
   * @param traits - User properties
   */
  identifyUser: (userId: string, traits?: Record<string, any>) => {
    mixpanel.identify(userId);
    if (traits) {
      mixpanel.people.set(traits);
    }
  },

  /**
   * Track user signup events
   * @param email - User email
   * @param source - Where the signup occurred (button location)
   */
  trackSignup: (email: string, source: string) => {
    mixpanel.track('Signup Form Submitted', { email, source });
  }
};

export default Analytics;